import * as React from "react";
const SvgClose = (props) => (
  <svg
    xmlns="https://www.w3.org/2000/svg"
    width="1em"
    height="1em"
    viewBox="0 0 512 512"
    {...props}
  >
    <path
      fill="none"
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={30}
      d="m396.893 115-282 282M114.893 115l282 282"
    />
  </svg>
);
export default SvgClose;
